<template>
  <div>
    <Main_nav />
    <div class="row">
      <div class="col-12" style="background-color: #f9f9f9">
        <main_filter_admin />
        <br />
      </div>
    </div>
    <div class="responsive-layout-report mx-auto">
      <div class="row">
        <div class="col-12">
          <br />
          <br />
          <b-row>
            <b-col class="d-block text-right mt-2"
              ><img src="../assets/icons/icons_general/icon_place_white.svg"
            /></b-col>
            <b-col class="d-block text-left">
              <b-row>
                <b-col cols="12" class="font-title">ชุมชนทั้งหมด</b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="font-extra mt-0"
                  style="color: #41634a; text-align: left"
                  >{{ all_community }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="col-12 row pl-5">
          <div class="col-12">
            <hr style="border: black solid 1px" />
          </div>
          <div class="col-2">ภาคกลาง</div>
          <div class="col-2">ภาคเหนือ</div>
          <div class="col-2">ภาคตะวันออกเฉียงเหนือ</div>
          <div class="col-2">ภาคตะวันออก</div>
          <div class="col-2">ภาคตะวันตก</div>
          <div class="col-2">ภาคใต้</div>

          <div class="col-2">{{ geography[2] }}<br />ชุมชน</div>
          <div class="col-2">{{ geography[1] }}<br />ชุมชน</div>
          <div class="col-2">{{ geography[3] }}<br />ชุมชน</div>
          <div class="col-2">{{ geography[5] }}<br />ชุมชน</div>
          <div class="col-2">{{ geography[4] }}<br />ชุมชน</div>
          <div class="col-2">{{ geography[6] }}<br />ชุมชน</div>
        </div>

        <div class="col-12">
          <b-row class="mt-5">
            <b-col cols="12" md="6" lg="4">
              <div
                class="rectangle_box my-1 mx-1"
                style="
                  background: #e6f0e9;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-row>
                  <b-col cols="4">
                    <img
                      style="
                        position: relative;
                        width: 110px;
                        right: -20%;
                        top: 25%;
                      "
                      src="../assets/icons/icons_general/icon_green_leaves.png"
                    />
                  </b-col>
                  <b-col cols="8" style="padding-top: 3%">
                    <p
                      class="font-extra text-left"
                      style="font-size: 35px; color: #000000; margin-bottom: 0"
                    >
                      จำนวนชนิดพืช
                    </p>
                    <p style="color: #41634a" class="font-extra text-left">
                      {{ group_by_plant }}
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <b-row
                class="rectangle_box my-1 mx-1"
                style="
                  background: #e6f0e9;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-col cols="4">
                  <img
                    style="position: relative; right: -20%; top: 25%"
                    src="../assets/icons/icons_general/icon_leaf_circle.svg"
                  />
                </b-col>
                <b-col cols="8" style="padding-top: 3%">
                  <p
                    class="font-extra text-left"
                    style="font-size: 35px; color: #000000; margin-bottom: 0"
                  >
                    ข้อมูลทั้งหมด
                  </p>
                  <p style="color: #41634a" class="font-extra text-left">
                    {{ all_data }}
                  </p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <b-row
                class="rectangle_box my-1 mx-1"
                style="
                  background: #e6f0e9;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-col cols="4">
                  <img
                    style="position: relative; right: -20%; top: 25%"
                    src="../assets/icons/icons_general/icon_green_check.png"
                  />
                </b-col>
                <b-col cols="8" style="padding-top: 3%">
                  <p
                    class="font-extra text-left"
                    style="font-size: 35px; color: #000000; margin-bottom: 0"
                  >
                    ตรวจสอบแล้ว
                  </p>
                  <p style="color: #41634a" class="font-extra text-left mb-0">
                    {{ all_approve }}
                    <span style="font-size: 40px"
                      >({{ all_approve_percent }}%)</span
                    >
                  </p>
                  <div
                    class="text-left"
                    style="font-size: 18px; position: absolute; bottom: 5%"
                  >
                    ของข้อมูลทั้งหมด
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="col-12">
          <b-row class="mt-4">
            <b-col cols="12" md="6" lg="4">
              <div
                class="rectangle_box my-1 mx-1"
                style="
                  background: #d8e2ee;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-row>
                  <b-col cols="4">
                    <img
                      style="
                        position: relative;
                        width: 110px;
                        right: -20%;
                        top: 25%;
                      "
                      src="../assets/icons/icons_general/icon_blue_1.png"
                    />
                  </b-col>
                  <b-col cols="8" style="padding-top: 3%">
                    <p
                      class="font-extra text-left"
                      style="font-size: 35px; color: #000000; margin-bottom: 0"
                    >
                      จำนวนชนิดสัตว์
                    </p>
                    <p style="color: #3b5286" class="font-extra text-left">
                      {{ 0 }}
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <b-row
                class="rectangle_box my-1 mx-1"
                style="
                  background: #d8e2ee;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-col cols="4">
                  <img
                    style="position: relative; right: -20%; top: 25%"
                    src="../assets/icons/icons_general/icon_blue_2.png"
                  />
                </b-col>
                <b-col cols="8" style="padding-top: 3%">
                  <p
                    class="font-extra text-left"
                    style="font-size: 35px; color: #000000; margin-bottom: 0"
                  >
                    ข้อมูลทั้งหมด
                  </p>
                  <p style="color: #3b5286" class="font-extra text-left">
                    {{ 0 }}
                  </p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <b-row
                class="rectangle_box my-1 mx-1"
                style="
                  background: #d8e2ee;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-col cols="4">
                  <img
                    style="position: relative; right: -20%; top: 25%"
                    src="../assets/icons/icons_general/icon_blue_check.png"
                  />
                </b-col>
                <b-col cols="8" style="padding-top: 3%">
                  <p
                    class="font-extra text-left"
                    style="font-size: 35px; color: #000000; margin-bottom: 0"
                  >
                    ตรวจสอบแล้ว
                  </p>
                  <p style="color: #3b5286" class="font-extra text-left mb-0">
                    {{ 0 }}
                    <span style="font-size: 40px">({{ 0 }}%)</span>
                  </p>
                  <div
                    class="text-left"
                    style="font-size: 18px; position: absolute; bottom: 5%"
                  >
                    ของข้อมูลทั้งหมด
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="col-12">
          <b-row class="mt-4 mb-5">
            <b-col cols="12" md="6" lg="4">
              <div
                class="rectangle_box my-1 mx-1"
                style="
                  background: #f5e3da;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-row>
                  <b-col cols="4">
                    <img
                      style="
                        position: relative;
                        width: 110px;
                        right: -20%;
                        top: 25%;
                      "
                      src="../assets/icons/icons_general/icon_orange_1.png"
                    />
                  </b-col>
                  <b-col cols="8" style="padding-top: 3%">
                    <p
                      class="font-extra text-left"
                      style="font-size: 35px; color: #000000; margin-bottom: 0"
                    >
                      จำนวนชนิดเห็ด
                    </p>
                    <p style="color: #db7f50" class="font-extra text-left">
                      {{ 0 }}
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <b-row
                class="rectangle_box my-1 mx-1"
                style="
                  background: #f5e3da;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-col cols="4">
                  <img
                    style="position: relative; right: -20%; top: 25%"
                    src="../assets/icons/icons_general/icon_orange_2.png"
                  />
                </b-col>
                <b-col cols="8" style="padding-top: 3%">
                  <p
                    class="font-extra text-left"
                    style="font-size: 35px; color: #000000; margin-bottom: 0"
                  >
                    ข้อมูลทั้งหมด
                  </p>
                  <p style="color: #db7f50" class="font-extra text-left">
                    {{ 0 }}
                  </p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <b-row
                class="rectangle_box my-1 mx-1"
                style="
                  background: #f5e3da;
                  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                  min-height: 100%;
                "
              >
                <b-col cols="4">
                  <img
                    style="position: relative; right: -20%; top: 25%"
                    src="../assets/icons/icons_general/icon_orange_check.png"
                  />
                </b-col>
                <b-col cols="8" style="padding-top: 3%">
                  <p
                    class="font-extra text-left"
                    style="font-size: 35px; color: #000000; margin-bottom: 0"
                  >
                    ตรวจสอบแล้ว
                  </p>
                  <p style="color: #db7f50" class="font-extra text-left mb-0">
                    {{ 0 }}
                    <span style="font-size: 40px">({{ 0 }}%)</span>
                  </p>
                  <div
                    class="text-left"
                    style="font-size: 18px; position: absolute; bottom: 5%"
                  >
                    ของข้อมูลทั้งหมด
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <div class="col-12 pl-5">
          <b-row>
            <b-col class="out-border-custom" cols="12" lg="6" md="12" sm="12">
              <div class="border-custom">
                <a
                  @click="toexcel(1)"
                  style="
                    position: absolute;
                    background-color: darkgreen;
                    color: white;
                    right: 11%;
                    top: 3%;
                    border-radius: 5px;
                    padding: 0 5px 0 5px;
                    cursor: pointer;
                  "
                >
                  excel
                </a>
                <name_section
                  type="report"
                  subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
                  title="สัดส่วนข้อมูลแต่ละกลุ่มชนิดพืช"
                  style="width: 100%"
                />
                <bar_chart_horizontal />
              </div>
            </b-col>
            <b-col class="out-border-custom" cols="12" lg="6" md="12" sm="12">
              <div class="border-custom">
                <a
                  @click="toexcel(2)"
                  style="
                    position: absolute;
                    background-color: darkgreen;
                    color: white;
                    right: 11%;
                    top: 3%;
                    border-radius: 5px;
                    padding: 0 5px 0 5px;
                    cursor: pointer;
                  "
                >
                  excel
                </a>
                <name_section
                  type="report"
                  subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
                  title="เปรียบเทียบข้อมูลแปลงสำรวจและแปลงธนาคาร"
                />
                <bar_chart />
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="col-12 pl-5 out-border-custom">
          <div class="border-custom">
            <a
              @click="toexcel(3)"
              style="
                position: absolute;
                background-color: darkgreen;
                color: white;
                right: 6%;
                top: 35px;
                border-radius: 5px;
                padding: 0 5px 0 5px;
                cursor: pointer;
              "
            >
              excel
            </a>
            <name_section
              title="ชุมชนที่ค้นหายอดนิยม "
              type="report"
              style="width: 30%"
            />
            <popular_search type="community" />
          </div>
        </div>
        <div class="col-12 pl-5 out-border-custom">
          <div class="border-custom">
            <a
              @click="toexcel(4)"
              style="
                position: absolute;
                background-color: darkgreen;
                color: white;
                right: 6%;
                top: 35px;
                border-radius: 5px;
                padding: 0 5px 0 5px;
                cursor: pointer;
              "
            >
              excel
            </a>
            <name_section
              title="ชนิดพืชที่ค้นหายอดนิยม "
              type="report"
              style="width: 30%"
            />
            <popular_search type="bio" />
          </div>
        </div>
        <div class="col-12 pl-5 out-border-custom">
          <div class="border-custom">
            <a
              @click="toexcel(5)"
              style="
                position: absolute;
                background-color: darkgreen;
                color: white;
                right: 6%;
                top: 35px;
                border-radius: 5px;
                padding: 0 5px 0 5px;
                cursor: pointer;
              "
            >
              excel
            </a>
            <name_section
              subtitle="ทุกชุมชน ทุกกลุ่มชนิดพืช ทุกภูมิปัญญา"
              title="พืชค้นหายอดนิยม"
              type="report"
              style="width: 40%"
            />
            <word_cloud />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Main_nav from "@/components/navbar";
import main_filter_admin from "@/components/main_filter_admin";
import bar_chart_horizontal from "@/components/bar_chart_horizontal_be";
import bar_chart from "@/components/bar_chart_be";
import word_cloud from "@/components/word_cloud_be";
import name_section from "@/components/name_section";
import popular_search from "@/components/popular_search";
import { mapState } from "vuex";
import { domain } from "../utils/Constants";

export default {
  name: "Report",
  components: {
    Main_nav,
    main_filter_admin,
    bar_chart_horizontal,
    bar_chart,
    word_cloud,
    name_section,
    popular_search,
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState({
      all_community: (state) => {
        return state.OptionsModule.community.length;
      },
      all_data: (state) => {
        return state.dashboardModule.all_data;
      },
      all_approve: (state) => {
        return state.dashboardModule.all_approve;
      },
      all_approve_percent: (state) => {
        return state.dashboardModule.all_approve_percent;
      },
      geography: (state) => {
        return state.dashboardModule.geography;
      },
      group_by_plant: (state) => {
        return state.dashboardModule.group_by_plant;
      },
    }),
  },
  methods: {
    toexcel(index) {
      let data = {
        geography: this.value1 ? this.value1.value : "",
        community: this.value2 ? this.value2.community_id : "",
        plotType: this.value3 ? this.value3.value : "",
        category: this.value4 ? this.value4.category_id : "",
        knowledge: this.value5 ? this.value5.knowledge_level1_id : "",
        habit: this.value6 ? this.value6.habitat_id : "",
        habitat: this.value7 ? this.value7.habit_id : "",
        benefit: this.value8 ? this.value8.benefit_id : "",
        status: this.value9 ? this.value9.value : "",
        publish: this.value10 ? this.value10.value : "",
      };
      // console.log(data);
      window.open(
        domain +
          "api/toexcel?index=" +
          index +
          "&geography=" +
          data.geography +
          "&community=" +
          data.community +
          "&plotType=" +
          data.plotType +
          "&category=" +
          data.category +
          "&knowledge=" +
          data.knowledge +
          "&habit=" +
          data.habit +
          "&habitat=" +
          data.habitat +
          "&benefit=" +
          data.benefit +
          "&status=" +
          data.status +
          "&publish=" +
          data.publish
      );
    },
    getData() {
      let data = {
        geography: "",
        community: "",
        plotType: "",
        category: "",
        knowledge: "",
        habit: "",
        habitat: "",
        benefit: "",
        status: "",
        publish: "",
      };
      this.$store.dispatch("dashboardModule/setDataBE", data);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.border-custom {
  /*border: black solid 1px;*/
  background: #ffffff;
  padding-bottom: 2%;
  margin: 2% 0 2% 0;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

.out-border-custom {
  padding-right: 5%;
}
</style>
